import TempNgoService from "../../services";

export default {
  namespaced: true,
  state: {
    // events: [],
    transaction :null,
    loading: false,
  },
  getters: {
    loading(state) {
      return state.loading;
    },
    events(state) {
      return state.events;
    },
    transaction(state) {
      return state.transaction;
    },
  },
  mutations: {
    setLoading(state, payload) {
      state.loading = payload;
    },

    // setEvents(state, payload) {
    //   state.events = payload;
    // },

    setTransaction(state, payload) {
      state.transaction = payload;
    },
  },

  actions: {
    // async fetchLog({ commit }) {
    //   commit("setLoading", true);
    //   try {
    //     const data = await TempNgoService.setEvents();
    //     commit("setEvents", data.data);
    //   } catch (err) {
    //   } finally {
    //     commit("setLoading", false);
    //   }
    // },
    async fetchTransaction({ commit }) {
      commit("setLoading", true);
      try {
        const data = await TempNgoService.fetchTransaction();
        commit("setTransaction", data.data);
      } catch (err) {
      } finally {
        commit("setLoading", false);
      }
    },
  },
};
